<span class="public-player-avatar" :style="avatarStyle" aria-hidden="true">
  <img v-if="avatarUrl" :src="avatarUrl" :alt="name || $t('navigation.user')" />
  <span v-else>{{ initials }}</span>
</span>
